import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="rs-section bg-[#F8FAFC]">
      <div className="rs-container">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <p className="rs-overline mb-4">FAQ</p>
            <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
              Answers to the questions we get most.
            </h2>
            <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
              Still curious? Reach out — we typically reply within a few hours.
            </p>
            <a href="#contact" data-testid="faq-cta" className="mt-8 inline-flex rs-btn-secondary">
              Ask a Question
            </a>
          </motion.div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {FAQS.map((item, idx) => (
                <AccordionItem
                  key={idx}
                  value={`item-${idx}`}
                  data-testid={`faq-item-${idx}`}
                  className="bg-white border border-slate-200 rounded-2xl px-5 data-[state=open]:border-[#F97316]/40 data-[state=open]:shadow-sm"
                >
                  <AccordionTrigger className="font-display font-semibold text-[#0A192F] text-base md:text-lg hover:no-underline py-5 text-left">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
